import { RydeAppUnit, RydeUiUnit } from "../models";

export type EntityPathKeys = keyof typeof entityPathMappings;

export const isEntityPathMapped = (
  entity: RydeUiUnit,
): entity is RydeAppUnit => {
  return entityPathMappings[entity as EntityPathKeys] !== undefined;
};

export const entityPathMappings: Record<RydeAppUnit, string> = {
  addition: "additions",
  area: "areas",
  areasGroup: "areas-groups",
  booking: "bookings",
  businessUnit: "business_units",
  complaint: "complaints",
  course: "courses",
  dashboard: "dashboard",
  dataUpload: "data_uploads",
  dayGroup: "day_groups",
  dayType: "day_types",
  disableHour: "disable_hours",
  driver: "drivers",
  feedback: "feedbacks",
  feedbackSolution: "feedback_solutions",
  feedbackSubject: "feedback_subjects",
  flight: "flights",
  foodSupplier: "food_suppliers",
  incident: "incidents",
  incidentType: "incident_types",
  journey: "journeys",
  meal: "meals",
  notification: "notifications",
  passenger: "passengers",
  passengerSector: "passenger_sectors",
  passengerType: "passenger_types",
  priceRate: "price_rates",
  produceButton: "produce_buttons",
  reason: "reasons",
  reasonCategory: "reason_categories",
  report: "reports",
  ride: "rides",
  rideMap: "rides-map",
  rideProduction: "ride_productions",
  rideType: "ride_types",
  shift: "shifts",
  shiftTemplate: "shift_templates",
  site: "sites",
  station: "stations",
  stationDistance: "station_distances",
  stationRoute: "station_routes",
  supplier: "suppliers",
  supplierPriceRate: "supplier_price_rates",
  systemManager: "system_managers",
  systemParam: "system_params",
  systemTag: "system_tags",
  tracking: "trackings",
  unit: "units",
  unknown: "",
  user: "users",
  vehicle: "vehicles",
  vehicleType: "vehicle_types",
  view: "views",
  geoArea: "geoAreas",
} as const;
